import { useAuthStore } from '@/stores/auth'

export const SAVED_FILTERS_KEY_PREFIX = 'filtros:'

export interface SavedFilterOperationalBase {
  id: string
  description: string
  companyId: string
}

export interface SavedFilter {
  filterName: string
  listCompany: string[]
  listOperationalBase: string[]
  /**
   * Base → empresa no momento em que o filtro foi salvo. O Painel não pode depender só de
   * `/OperationalBases/All` para isso: para perfis não-admin ele não traz (ou não relaciona à
   * empresa) todas as bases que o modal oferece. Ausente em filtros salvos antes desse campo.
   */
  operationalBases?: SavedFilterOperationalBase[]
  listDriver: string[]
  listEventType: number[]
  listEventsLevel: number[]
  initialDate: string | null
  finalDate: string | null
  likeVehicle: string | null
}

function storageKey(): string | null {
  const userId = useAuthStore.getState().user?.id
  return userId ? `${SAVED_FILTERS_KEY_PREFIX}${userId}` : null
}

export function loadSavedFilters(): SavedFilter[] {
  const key = storageKey()
  if (!key) return []
  try {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as SavedFilter[]) : []
  } catch {
    return []
  }
}

export function persistSavedFilters(filters: SavedFilter[]): void {
  const key = storageKey()
  if (!key) return
  localStorage.setItem(key, JSON.stringify(filters))
}
